import axios from "axios";

export class ReturnTicketsViewModel {
    constructor() {
        this.InitBindings();
    }

    private GetSelectedTicketBreakdownIds() {
        var selectedTicketBreakdownIds: string[] = [];
        $('#div-ticket-info input:checked').each(function () {
            selectedTicketBreakdownIds.push(($(this).attr('id')).substring(3));
        });

        return selectedTicketBreakdownIds;
    }

    private InitBindings() {
        var selectedTicketBreakdownIds: string[] = this.GetSelectedTicketBreakdownIds();
        $('#btn-process-cancellation').prop("disabled", selectedTicketBreakdownIds.length == 0);

        $('.form-check-input').click(() => {            
            var selectedTicketBreakdownIds: string[] = this.GetSelectedTicketBreakdownIds();
            $('#btn-process-cancellation').prop("disabled", selectedTicketBreakdownIds.length == 0);
        });
        $('#btn-process-cancellation').click(() => {  
            $('#btn-process-cancellation').prop("style", "display:none;");
            $('.page-spinner').prop("style", "display:flex;");
            const newParams = new URLSearchParams();
            new URLSearchParams(window.location.search).forEach(function (value, name) { newParams.append(name.toLowerCase(), value); });

            var selectedTicketBreakdownIds: string[] = this.GetSelectedTicketBreakdownIds();

            axios.post(window.location.href, {
                ticketBreakdownIds: selectedTicketBreakdownIds,
                bookingUrl: newParams.get('bookingurl')
            }, {
                withCredentials: true
            })
                .then(function (pendingTickets) {
                    var tickets = pendingTickets.data;

                    if (tickets.confirmationToken) {
                        var confirmationToken = (typeof tickets.confirmationToken === 'string' ? tickets.confirmationToken : null);
                        window.location.href = (window as any).env.checkoutSitePath + '/event/checkout/canceltickets/confirmed?confirmationToken=' + confirmationToken;
                    } else {
                        $('.div-ticket-list').prop("style", "display:none;");
                        $('#span-title').text('Almost There...');
                        $('#div-header-message').text("Last step, we just need you to confirm your cancellation isn't a mistake. An email with a confirmation link has been sent to your inbox. " +
                            "If you haven't received an email within 10 minutes, please check your spam folder.");
                        $('#div-subheader-message').text('This link is valid for ' + tickets.linkValidity + ' hours, or until the event booking window closes.');
                        var ticketListDivs = $("div[id^='ticket-info-']");
                        var groupIds = tickets.ticketBreakdownGroups.map((a: { groupId: any; }) => a.groupId);
                        for (var i = 0; i < ticketListDivs.length; i++) {
                            if (!groupIds.includes(ticketListDivs[i].id.substring(12))) {
                                ticketListDivs[i].style.display = "none";
                            }
                        }

                        tickets.ticketBreakdownGroups.forEach(function (tbg: any) {
                            var infoText = '';
                            if (tbg.section.sectionTypeId == 2) {
                                var seatList = '';
                                tbg.ticketBreakdowns.forEach(function (tb: any) {
                                    seatList += ", " + tb.rowName + tb.seatNumber;
                                })
                                infoText = "Seat/s: " + seatList.substring(2);
                            } else {
                                infoText = "Attendee x " + tbg.ticketBreakdowns.length;
                            }
                            $('#info-text-' + tbg.groupId).text(infoText);
                        });

                        $('.page-spinner').prop("style", "display:none;");
                    }
                })
                .catch(function (error) {
                    $('#div-header-message').text(error.response.data.message);
                    $('#div-subheader-message,#div-ticket-info,#btn-process-cancellation,#btn-booking-info,.page-spinner').prop("style", "display:none;");
                });
        });
    }

}
